import { Component, OnInit, inject } from '@angular/core';

import { CdsSize, CdsStyle } from '@cds/ng-core/configuration';
import { CDS_POPUP_DATA, MatDialogRef } from '@cds/ng-web-components/popup';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

interface CdWarningPopupButton {
  style: CdsStyle;
  size: CdsSize;
  text: string;
  cb: () => void;
}

@Component({
  selector: 'app-cd-warning-popup',
  templateUrl: './cd-warning-popup.component.html',
  styleUrls: ['./cd-warning-popup.component.scss'],
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class CdWarningPopupComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<CdWarningPopupComponent>>(MatDialogRef);
  data = inject<{
    isShowCloseIcon: boolean;
    title: string;
    buttons: CdWarningPopupButton[];
    messages: string[];
    closeCallBack?: () => void;
  }>(CDS_POPUP_DATA);

  ngOnInit(): void {}

  close() {
    this.dialogRef.close();

    if (this.data.closeCallBack) {
      this.data.closeCallBack();
    }
  }
}
